import EventEmitter from 'src/helpers/EventEmitter'
// import MediaStreamRecorder from 'msr' // media strean recorder
// import WebrtcAdapter from 'webrtc-adapter'
import Recorder from 'recorder-js';
import { context, analyser, frequencies, startAnalyser, stopAnalyser } from 'src/helpers/WebAudio'
import { audioBufferToWav, bufferToBase64 } from '@/helpers/AudioUtils'
import Artyom from "artyom.js"
import Raf from '@/helpers/Raf'
import 'url-search-params-polyfill'

const Events = {
  Audio: {
    Ready: 'Audio.Ready',
    FreqUpdate: 'Audio.FreqUpdate'
  },
  Consented: 'Audio.Consented'
}

let playback = false;
let urlParams = new window.URLSearchParams(window.location.search)
if (urlParams.get('playback') !== null) {
  playback = true;
}

let RECORD_STATES =  {
  NOT_STREAMING: 'RECORD_STATE:NOT_STREAMING',
  STREAMING: 'RECORD_STATE:STREAMIMG',
  RECORDING: 'RECORD_STATE:RECORDING'
};
let record_state = null; 

// Set the name of the hidden property and the change event for visibility
let hidden
let visibilityChange; 
if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
  hidden = "msHidden";
  visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}


class WebAudioService {

  constructor(config) {

    this.config = {

      debug: {
        playback: playback
      },

      isMobile: /(iPhone|iPad|iPod|Android)/i.test(navigator.userAgent),

      AUDIO_ENCODE: 'wav',
      AUDIO_CHANNELS: 1 
    }

    Object.assign(this, EventEmitter);  

    this.initial_prompt = true;
    this.recorder = new Recorder(context, {});
    record_state = RECORD_STATES.NOT_STREAMING;

    this.setupWebAudio();
    this.setupMediaStream();
  
    document.addEventListener(visibilityChange, this.handleVisibilityChange, false);

    // initiate stream to again user consent
    //this.handleVisibilityChange();

    this.startStream();
    //document.addEventListener('touchstart touchend', this.handleTouchStream, false); 
  }
 

 
  // If the page is hidden, pause the video;
  // if the page is shown, play the video
  handleVisibilityChange = () => {
    if (document[hidden]) { 
      if( record_state === RECORD_STATES.STREAMING ){
        this.stopStream();
      }
    } else { 
      //if( record_state === RECORD_STATES.STREAMING ){
        this.startStream();
      //}
    }
  }

  handleTouchStream = () => {  
    document.removeEventListener('touchstart touchend', this.handleTouchStream, false);
    this.startStream(); 
  }


  setRecordState(state){
    record_state = state; 
  }

  setupWebAudio() {}

  setupMediaStream() {
    if(this.config.isMobile){ 
      // mobile
    } else {
     // this.setupSpeechRecognition();
    } 
  }

  setupSpeechRecognition() {
    this.artyom = new Artyom();
    var that = this;
    this.artyom.on(['Tinkerbell *', 'Tinker Bell *', 'surly *'], true).then((i, wildcard) => {

      let data = JSON.stringify({
         'text': wildcard
      })

      // axios.post('/sentiment-analysis', data, {
      //   headers: {
      //     'Content-Type': 'application/json'
      //   }
      // })
      // .then(that.onSuccess)
      // .catch(function (error) {
      //   console.log(error);
      // });
    });

    // Start the commands !
    let options = {
    lang: "en-US", // GreatBritain english
    continuous: true, // Listen forever
    soundex: true, // Use the soundex algorithm to increase accuracy
    debug: true, // Show messages in the console
    listen: true // Start to listen commands !
    };
    this.artyom.initialize(options).then(() => {
      console.log("succesfully initialized");
    }).catch((err) => {
      console.error("couldn't be initialized: ", err);
    });

    //this.updateObey();
  }

  startStream = () => { 
 
    if( record_state === RECORD_STATES.NOT_STREAMING ){
      let config = { audio: true }
      navigator.mediaDevices.getUserMedia(config)
        .then(this.onStreamSuccess)
        .catch(this.onStreamError);
    } 
  }

  stopStream() {

    var track = this.stream.getTracks()[0];  // if only one media track  
    track.stop(); 
    this.setRecordState(RECORD_STATES.NOT_STREAMING);
    // console.log('stopStream') 
  }
 
  onStreamSuccess = (stream) => {
    
    this.stream = stream;
    this.source = context.createMediaStreamSource(stream); 
    this.source.connect(analyser); 
    this.recorder.init(stream);

    this.setRecordState(RECORD_STATES.STREAMING);  
    this.emit(Events.Consented, true)

    // this.mediaRecorder.mimeType = 'audio/' + this.config.AUDIO_ENCODE;
    // this.mediaRecorder.audioChannels = this.config.AUDIO_CHANNELS; 

    if(this.initial_prompt){
      this.stopStream()
      this.initial_prompt = false;
    }
  }

  onStreamError = (e) => { 
    console.log(e)
    this.emit(Events.Consented, false)
  }
 
  blobToBuffer(blob, cb) {

    var reader = new FileReader();

    function onLoadEnd(e) {
      reader.removeEventListener('loadend', onLoadEnd, false);
      if (e.error) {
          cb(e.error);
      } else {
          cb(reader.result);
      }
    }

    reader.addEventListener('loadend', onLoadEnd, false);
    reader.readAsArrayBuffer(blob);
  }

  onBlobToArrayBufferComplete = (arrayBuffer) => { 
    context.decodeAudioData(arrayBuffer, this.onArrayBufferToAudioBufferComplete, this.onArrayBufferToAudioBufferError);
  }

  onArrayBufferToAudioBufferComplete = (audioBuffer) => {

    let wavArrayBuffer = audioBufferToWav(audioBuffer);
    let base64 = bufferToBase64(wavArrayBuffer);

    if(this.config.debug.playback){
      let source = context.createBufferSource();  
      source.buffer = audioBuffer; 
      source.connect(context.destination); 
      source.start(0);
    } 

    this.emit(Events.Audio.Ready, base64);
  }

  onArrayBufferToAudioBufferError(err){
    console.error('ArrayBuffer > AudioBuffer', err)
  }



  // START RECORDING - - - - - - - -

  record() { 

    if(this.config.isMobile){

      let canRecord = (record_state === RECORD_STATES.STREAMING);
      console.log('canRecord ', canRecord, ' ', record_state)
      if( canRecord ){
        this.recorder.start()
          .then(this.onRecordStartSuccess)
          .catch(this.onRecordStartError)
      }
    } else {
      if(this.artyom){
        this.artyom.obey();
      }
    }
  } 

  onRecordStartSuccess = () => { 
    startAnalyser(false, true);
    this.setRecordState(RECORD_STATES.RECORDING);
  }

  onRecordStartError = (err) => { 
    console.log('onRecordError ', err); 
  }



  // STOP RECORDING - - - - - - - -

  stopRecording() { 

    if(this.config.isMobile){

      let canStopRecording = (record_state === RECORD_STATES.RECORDING);
      if( canStopRecording ){
        this.recorder.stop()
          .then(this.onRecordCompleteSuccess)
          .catch(this.onRecordCompleteError);
      }

      stopAnalyser(); 
      this.stopStream()

    } else {
      if(this.artyom){
        this.artyom.dontObey();
      }
    } 
  }
 
  onRecordCompleteSuccess = ({blob, buffer}) => {
    this.blobToBuffer(blob, this.onBlobToArrayBufferComplete); 
  }

  onRecordCompleteError = (err) => {
    console.log('onRecordedError ', err); 
  }

}

let service = new WebAudioService()
service.Events = Events
window.WebAudioService = service
export default service
